import React from "react";
import withIntl from "../../../../utils/withIntl";
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import PrintArticleLine from "../../PrintArticleLine";
import PrintInhouseOrderView from "./PrintInhouseOrderView";

function InhouseOrderLayoutEdit(props) {
  const layoutOptions = props.layoutOptions;
  const setLayoutOptions = props.setLayoutOptions;
  return (
    <>
      <Typography variant={"h6"} style={{ fontWeight: 800 }}>
        Inhouse Kitchen Tickets
      </Typography>
      <Grid container>
        <Grid container spacing={1} item xs={8}>
          <Grid item xs={6}>
            Margin top
          </Grid>
          <Grid item xs={6}>
            <TextField
              type={"number"}
              value={layoutOptions.order.margin_top}
              onChange={(e) => {
                layoutOptions.order.margin_top = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            Margin bottom
          </Grid>
          <Grid item xs={6}>
            <TextField
              type={"number"}
              value={layoutOptions.order.margin_bottom}
              onChange={(e) => {
                layoutOptions.order.margin_bottom = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            Print remark at:
            <Select
              value={layoutOptions.order.print_remark_at ?? "bottom"}
              onChange={(e) => {
                layoutOptions.order.print_remark_at = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            >
              <MenuItem value={"bottom"}>Bottom</MenuItem>
              <MenuItem value={"top"}>Top</MenuItem>
            </Select>
            Font type remark:
            <Select
              value={layoutOptions.order.font_type_remark ?? "medium"}
              onChange={(e) => {
                layoutOptions.order.font_type_remark = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            >
              <MenuItem value={"medium"}>General font size</MenuItem>
              <MenuItem value={"large"}>Table number font size</MenuItem>
              <MenuItem value={"small"}>Custom font size 1</MenuItem>
              <MenuItem value={"huge"}>Custom font size 2</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order.articlegroup_names_above_articles ?? false}
                  onChange={(e) => {
                    layoutOptions.order.articlegroup_names_above_articles = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={props.intl.formatMessage({ id: "print_articlegroups" })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order.subtotal ?? false}
                  onChange={(e) => {
                    layoutOptions.order.subtotal = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={props.intl.formatMessage({ id: "show_subtotal" })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order.buzzer ?? false}
                  onChange={(e) => {
                    layoutOptions.order.buzzer = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Play buzzer when printing"}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography style={{ fontWeight: 800 }}>{props.intl.formatMessage({ id: "article_layout" })}</Typography>
            {layoutOptions.order.article &&
              layoutOptions.order.article.lines.map((articleLine, index) => {
                return (
                  <PrintArticleLine
                    articleLine={articleLine}
                    onRemoveLine={() => {
                      layoutOptions.order.article.lines.splice(index, 1);

                      setLayoutOptions({ ...layoutOptions });
                    }}
                    setArticleLine={(newArticleLine) => {
                      articleLine = newArticleLine;
                      let newLayoutOptions = { ...layoutOptions };

                      setLayoutOptions(newLayoutOptions);
                    }}
                  />
                );
              })}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              size={"small"}
              onClick={() => {
                layoutOptions.order.article.lines.push({ elements: [], font_size: "medium" });
                setLayoutOptions({ ...layoutOptions });
              }}
            >
              Add new line
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order.article.newline ?? false}
                  onChange={(e) => {
                    layoutOptions.order.article.newline = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"New line"}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <PrintInhouseOrderView layoutOptions={layoutOptions.order} />
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(InhouseOrderLayoutEdit);
